import {Injectable} from '@angular/core';
import {NavFactory} from './nav.factory';
import {NavItemCodes} from '../../enums/nav-item-codes.enum';
import {PermissionArea} from '../../enums/permission-area.enum';
import {IconCode} from '../../enums/icon-code.enum';

@Injectable()
export class NavSalesPgFactory extends NavFactory {

    protected static items = [
        {
            code: NavItemCodes.POLICY_ADD,
            icon: IconCode.POLICY_ADD,
            label: 'NAV.POLICY_ADD.LABEL',
            description: 'NAV.POLICY_ADD.DESC',
            path: '/sales/pg',
            permissionArea: PermissionArea.SALES_UPG,
            cy: 'sales-pg',
        },
    ];
}
